import React from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import {AddOutlined, DeleteOutlined, EditOutlined} from '@material-ui/icons';
import PageWrapper from '../../../shared/pagewrapper/PageWrapper.js';
import PageTitle from '../../../shared/pagetitle/PageTitle.js';
import DataGrid from '../../../shared/datagrid/DataGrid.tsx';
import BlockUI from '../../../shared/blockui/BlockUI.tsx';
import ContainedButton from '../../../shared/buttons/ContainedButton.tsx';
import PageNaoEncontrada from '../../../PageNaoEncontrada.jsx';
import {criarColunaOpcoes} from '../../components/ColunaOpcoes.jsx';
import DialogCadastroDescricao from '../../dialogs/cadastro/DialogCadastroDescricao.jsx';
import useCadastroBasico from '../../components/cadastro/useCadastroBasico.js';
import {ouTraco} from '../../components/inscricao/documentoInscricao.js';
import useCheckModule from '../../../../hooks/useCheckModule.js';
import {buttonTableCell, containerPaper} from '../../../../utils/styles.js';
import {PAGINACAO_PADRAO, textoSemRegistros} from '../../components/paginacao.js';

const FILTER_OPTIONS = {filterByColumn: true};
const TABLE_CONTAINER_PROPS = {component: 'div'};

const useStyles = makeStyles(theme => ({
    ...containerPaper(theme),
    ...buttonTableCell(theme)
}));

/*
 * Tela de cadastro que só tem descrição (Programa, Tipo de Habitação e Tipo de
 * Moradia): lista com filtro e paginação, e criação/edição em diálogo.
 * `nomeItem` é o nome usado nos títulos do diálogo e nas mensagens de sucesso
 * (ex.: "Tipo de habitação"); `modulo` é o módulo (SYSBENEF) que libera a tela.
 */
export default function PageCadastroDescricao({titulo, nomeItem, url, modulo}) {
    const classes = useStyles();
    const checkModule = useCheckModule();
    const podeAcessar = !modulo || checkModule(modulo);
    const {
        itens,
        carregando,
        salvando,
        dialogAberto,
        fecharDialog,
        itemEmEdicao,
        adicionar,
        editar,
        salvar,
        excluir
    } = useCadastroBasico({url, nomeItem, habilitado: podeAcessar});

    if (!podeAcessar) {
        return <PageNaoEncontrada/>;
    }

    return (
        <PageWrapper>
            <PageTitle title={titulo}/>
            <Paper className={classes.containerPaper}>
                <BlockUI loading={carregando}>
                    <DataGrid
                        rows={itens}
                        comparatorKeys={['id']}
                        filterOptions={FILTER_OPTIONS}
                        paginate
                        paginateOptions={PAGINACAO_PADRAO}
                        tableContainerProps={TABLE_CONTAINER_PROPS}
                        noRecordsText={textoSemRegistros(carregando)}
                        toolbarContent={(
                            <ContainedButton startIcon={<AddOutlined/>} onClick={adicionar}>
                                Adicionar
                            </ContainedButton>
                        )}
                        columns={[
                            {label: 'Descrição', field: 'descricao', filterable: true, valueGetter: valor => ouTraco(valor)},
                            criarColunaOpcoes(row => [
                                {titulo: 'Editar', icone: <EditOutlined/>, onClick: () => editar(row)},
                                {titulo: 'Excluir', icone: <DeleteOutlined/>, onClick: () => excluir(row)}
                            ], {className: classes.buttonTableCell})
                        ]}/>
                </BlockUI>
            </Paper>
            <DialogCadastroDescricao
                open={dialogAberto}
                onClose={fecharDialog}
                nomeItem={nomeItem}
                item={itemEmEdicao}
                salvando={salvando}
                onSalvar={salvar}/>
        </PageWrapper>
    );
}

PageCadastroDescricao.propTypes = {
    titulo: PropTypes.string.isRequired,
    nomeItem: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    modulo: PropTypes.string
};
